/**
 * Number Formatting Utilities
 * Functions for formatting money and counts with adaptive suffixes
 */

/**
 * Format money with adaptive K/M suffix
 * Examples: $5, $1.5K, $30K, $1.2M
 */
export function formatMoneyAdaptive(amount: number): string {
  if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  }
  if (amount >= 1000) {
    const decimals = amount >= 10000 ? 0 : 1;
    return `$${(amount / 1000).toFixed(decimals)}K`;
  }
  return `$${amount.toFixed(0)}`;
}

/**
 * Format count without decimals
 * Examples: 5, 1K, 30K, 1.5M
 */
export function formatCountNoDecimal(count: number): string {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M`;
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(0)}K`;
  }
  return count.toString();
}
